<template>
  <div>
    <div v-if="dataFound && details.length > 0" class="page-content">
      <div style="text-align:center">
        <h2 class="headline mb-4">Transaction History</h2>
      </div>

      <div style="margin-bottom:20px;" class="container">
        <div style="border-radius:10px;border-left:#2C80FF 4px solid;border-right:#2C80FF 4px solid" class="content-area card p-1">
          <!-- <div style="padding:15px;border:1px black" class="input-group">
            <input
              type="search"
              v-model=name
              style="border-right:0;"
              placeholder="Search by Email address"
              aria-describedby="button-addon1"
              class="form-control bg-light"
            >
            <div class="input-group-append">
              <button
                type="submit"
                style="border-radius:0px 3px 3px 0px;border-left:0px "
                class="border bg-light px-2 py-0 text-primary btn-link"
              >
                <em class="fa fa-search"></em>
              </button>
            </div>
          </div> -->

          <div class="">
            <!-- <div class="card-head">
              <h4  class="card-title">KYC List</h4>
            </div> -->
            <div class="" v-if="getUserData.length > 0">
              <vue-good-table
                 
               
                  :search-options="{
                    enabled: true,
                    externalQuery: search,
                    skipDiacritics: true,
                    searchFn: searchData,
                    placeholder:
                      'Search by Email address',
                  }"
                  style="width:auto;z-index:0;border-radius:10px;"
                  :columns="columns"
                :sort-options="{
    enabled: true,
   
  }"
                  :rows="details"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 4,
                    position: 'bottom',
                    perPageDropdown: [5,3,7,10,15,20],
                   
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',

                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                     dropdownAllowAll: true
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'discounts'">
                      <p class="mb-0">
                      
                     
                        {{ props.row.discount }} TRX ({{props.row.discountPrice}}$)
                    </p>
                    & 
                    <p>{{props.row.discountPer}} % </p>
                    </span>

                     <span  v-if="props.column.field == 'amounts'">
                      <p class="mb-0">{{ props.row.amount }} TRX
                      
                     
                       <p style="font-size:13px"> ({{ props.row.originalAmount }}) $</p>

                      </p>
                     </span>
                     <span  v-clipboard="props.row.address"
                      data-placement="left" title="Click here to copy address" 
              @success="success"
          
              @error="failed" style="cursor:pointer"  v-if="props.column.field == 'address'">
                       <span
                      
                       >{{props.row.address}}</span>

                     </span>

                      <!-- <span
                        class="dt-status-sm badge badge-sq badge-outline badge-success badge-md"
                        >A</span
                      > -->
                   
                    
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>
                  <template slot="table-column" slot-scope="props">
     <span  v-if="props.column.label ==''">
         Date & Time <br> <span class="ma-0 pa-0" style="font-size:11px">(MM/DD/YYYY, HH:MM:SS)</span>
     </span>
    <span v-if="props.column.label=='Discount'">
      Discount <br><span style="font-size:11px">($ & %)</span>
    </span>
     <span v-else>
        {{props.column.label}}
     </span>
  </template>
                </vue-good-table>
            </div>
            <div v-else>
              <center>
                <i
                  style="font-size:35px;color:grey"
                  class="far fa-frown mb-3"
                  aria-hidden="true"
                ></i>
                <h4 class="font-bold">No search results found</h4>
              </center>
            </div>
            <!-- <div v-else>
              <center>
                <i style="font-size:35px;color:grey" class="far fa-frown mb-3" aria-hidden="true"></i>
                <h4 class="font-bold">No search results found</h4>
              </center>
            </div> -->
          </div>
          <!-- .card-innr -->
        </div>
        <!-- .card -->
      </div>
      <!-- <div v-else class="container">
        <div class="content-area card">
          <div class="card-innr">
            <center class="card-body">
              <i style="font-size:50px;color:grey" class="far fa-frown pa-5" aria-hidden="true"></i>
              <h2 class="mt-5 font-bold">No data available to display</h2>
            </center>
          </div>
        </div>
      </div> -->
    </div>
    <div
      v-else-if="dataFound == false"
     
      style="margin-top:6%;"
    >
        <div class="row justify-content-center">
          <div
            style="border:0.9px solid blue;border-radius:10px;"
            class="card col-6"
          >
            <div class="card-body">
              <center class="card-body">
                <i
                  style="font-size:250px;color:grey"
                  class="far fa-frown pa-5"
                  aria-hidden="true"
                ></i>
                <h2 class="mt-5 font-bold">No data available to display</h2>
              </center>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";


export default {
  name: "History",
  data() {
    return {
      details: [],
      temp: [],
      name: "",
       columns: [
        { label: "User Address", field: "address",tdClass:'text-center',thClass:'text-center'},
        { label: "User Email", field: "email",tdClass:'text-center',thClass:'text-center' },
        { label: "", field: "date",tdClass:'text-center',thClass:'text-center' },
        { label: "Amount paid($)", field: "amounts",tdClass:'text-center',thClass:'text-center' },
        { label: "Discount", field: "discounts",tdClass:'text-center',thClass:'text-center' },
      ],
     
      count: 0,
      dataFound: undefined,
      len: undefined,
      web3: this.$store.state.web3,
      currentAddress: this.$cookies.get("address"),
    };
  },
  asyncComputed: {
    async getUserData() {
      if (this.name != "") {
        return this.details.filter((data) => {
          let email = data.email.toLowerCase();
          this.name = this.name.toLowerCase();
          return email.startsWith(this.name);
        });
      } else {
        return this.details;
      }
    },
  },
  methods: {
    success() {
      this.$toasted.global.my_app_success({
        message: "Address copied to clipboard",
      });
    },
    failed() {
      this.$toasted.global.my_app_error({
        message: "Address copied to clipboard",
      });
    },
    searchData(row, col, cellValue, searchTerm) {
      console.log(searchTerm);
      return (
        row.email.toLowerCase().startsWith(searchTerm.toLowerCase())
       
      );
    },
    async getLen() {
      let party = await this.$store.state.KYC.getPartyDetails().call({
        from: this.currentAddress,
      });
      console.log(party);
      this.len = party.arr.length;
      this.partyName = party.partyName;

      if (this.len <= 0) {
        this.dataFound = false;
        this.$store.state.loading = false;
      }
    },
    async setNewData(userAddress, amount, timeStamp, discount, email, price) {
      timeStamp = parseInt(timeStamp);
      try {
        this.$store.state.loading = true;
        userAddress = await this.$store.state.tronWeb.address.fromHex(
          userAddress
        );
        let blocked = await this.$store.state.KYC.blocked(userAddress).call({
          from: this.currentAddress,
        });
        console.log(blocked);
        if (!blocked) {
          console.log("hmmm");
          // let len=await this.$store.state.KYC.getEmailLength(userAddress).call({from:this.currentAddress});
          let newAmount = 0;
          let newDiscount = 0;
          let per = 0;
          let originalAmount = 0;
          let discountPrice = 0;

          if (amount > 0) {
            newAmount = await this.$store.state.tronWeb.fromSun(amount);
            newAmount = parseFloat(newAmount).toFixed(2);

            newDiscount = await this.$store.state.tronWeb.fromSun(discount);
            newDiscount = parseFloat(newDiscount).toFixed(2);
            let val1 = discount * 1000000 * 100;
            let val2 = discount * 1000000 + amount * 1000000;
            per = val1 / val2;

            per = parseFloat(per).toFixed(1);
            per = per > 0 ? per : 0;

            //price = price > 1 ? 4 : price;
            originalAmount = parseFloat(price - (price * per) / 100).toFixed(2);
            originalAmount = originalAmount > 0 ? originalAmount : 0.0;

            discountPrice = ((price * per) / 100).toFixed(2);
            discountPrice = discountPrice > 0 ? discountPrice : 0.0;
          } else {
            newAmount = parseFloat(newAmount).toFixed(1);
            newDiscount = parseFloat(newDiscount).toFixed(1);
          }

          let newUserAddress = userAddress;
          //let date = await this.web3.eth.getBlock(blockNumb);
          let date1 = new Date(timeStamp);
          console.log(date1);
          date1 = date1.toLocaleString("en-GB");
          email=email;
          let obj = {
            address: newUserAddress,
            amount: newAmount,
            discount: newDiscount,
            discountPer: per,
            originalAmount: originalAmount,
            email: email,
            date: date1,
            timestamp: timeStamp,
            price: price,
            discountPrice: discountPrice,
          };

          await this.temp.push(obj);
          this.details = this.temp;
          console.log(this.details);
          this.details = this.details.sort(
            (d1, d2) => new Date(d2.timestamp) - new Date(d1.timestamp)
          );
          this.$store.state.loading = false;
          //  if(this.len-this.count==(this.details.length)){
          //       this.$store.state.loading=false;
          //   }
        } else {
          console.log("Blocked:", userAddress);
          this.count++;
        }
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
  },

  async created() {
    this.$store.state.loading = true;
    await this.$store.dispatch("setContract");
    await this.getLen();

    await this.$store.dispatch("getDepositedAmount", this.currentAddress);
    let key = process.env.VUE_APP_API_KEY;

    try {
      let partyEvents = await axios({
        url:
          this.$store.state.eventUrl +
          "payments/" +
          this.currentAddress,
        method: "get",

        headers: {
          Authorization: "Basic " + key,
        },
      });
      partyEvents = partyEvents.data.data.events;
      console.log('party:',partyEvents);
      for (let i = 0; i < partyEvents.length; i++) {
        this.dataFound = true;
        this.setNewData(
          partyEvents[i].result.user,
          partyEvents[i].result.amount,
          partyEvents[i].block_timestamp,
          partyEvents[i].result.discount,
          partyEvents[i].result.email,
          partyEvents[i].result.price
        );
        // this.dataFound=true;
        // await this.getGov(
        //   partyEvents[i].,
        //   this.$store.state.tronWeb.address.fromHex(govEvents[i].result.gov)
        // );
      }
    } catch (err) {
      console.log(err);
    }
  },
};
</script>
<style scoped>
@import "../assets/css/style.css";
@import "../assets/css/vendor.bundle.css?ver=104";
@import "../assets/css/style.css?ver=104";

.setText{
  text-align: center;
  margin-top:auto;
}
</style>
